import React from 'react';
import { useTranslation } from 'react-i18next';

import ActivityReportingButtonsContainer from '@t7x000/apex-web/lib/components/ActivityReportingComponents/index.js';
import ScheduledReportsTableContainer from '@t7x000/apex-web/lib/components/ReportSidePaneComponents/ScheduledReportsTable';
import DownloadReportContainer from '@t7x000/apex-web/lib/components/ReportSidePaneComponents/DownloadReportForm';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import './TradeReportPage.css';

const tradeReportPageClasses = getBEMClasses('trade-report-page');

const TradeReportPage = () => {
  const { t } = useTranslation();

  return (
    <div className={tradeReportPageClasses()}>
      <div className={tradeReportPageClasses('activity-report')}>
        <div className={tradeReportPageClasses('activity-report-header')}>
          <div className={tradeReportPageClasses('activity-report-header-title')}>{t('Activity Reporting')}</div>
          <div className={tradeReportPageClasses('activity-report-header-text')}>
            {t(
              'All of your activity on the platform is available for you to download as a spreadsheet. Simply choose the type of activity and the timeframe to generate your report.',
            )}
          </div>
        </div>
        <div className={tradeReportPageClasses('activity-report-buttons')}>
          <ActivityReportingButtonsContainer />
        </div>
      </div>
      <div className={tradeReportPageClasses('cyclical-report')}>
        <div className={tradeReportPageClasses('report-header')}>{t('Cyclical Reports')}</div>
        <ScheduledReportsTableContainer />
      </div>
      <div className={tradeReportPageClasses('singal-report')}>
        <div className={tradeReportPageClasses('report-header')}>{t('Reports Available to Download')}</div>
        <DownloadReportContainer />
      </div>
    </div>
  );
};

export default TradeReportPage;
